module.exports = __webpack_public_path__ + "img/17.cb56873d.png";